import { useEffect, useState } from "react";

import api from "../../../api";
import { ZmDeclarationEntry } from "../../../types";

export function useZmDeclarations(email: string) {
  const [declarations, setDeclarations] = useState<ZmDeclarationEntry[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);

    api.kontax
      .getZmUserDeclarations(email)
      .then(setDeclarations)
      .catch(() => setDeclarations([]))
      .finally(() => setLoading(false));
  }, [email]);

  return { declarations, loading };
}
